import { createSlice } from "@reduxjs/toolkit";
import { sendOtpAuth, verifyOtpAuth } from "./thunks";

export const initialState = {
  user: {},
  error: "",
  loading: false,
  otpSent: false,
  verified: false,
  mobile: "",
  errorMsg: false,
  successMsg: "",
};

const otpLoginSlice = createSlice({
  name: "otpLogin",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setOtpSent(state, action) {
      state.otpSent = action.payload;
    },
    setMobile(state, action) {
      state.mobile = action.payload;
    },
    apiError(state, action) {
      if (typeof action.payload === 'string') {
        state.error = action.payload;
      } else if (action.payload?.message) {
        state.error = action.payload.message;
      } else if (action.payload?.error) {
        state.error = action.payload.error;
      } else {
        state.error = "An error occurred";
      }
      state.loading = false;
      state.errorMsg = true;
      state.successMsg = "";
    },
    reset(state) {
      state.user = {};
      state.error = "";
      state.loading = false;
      state.otpSent = false;
      state.verified = false;
      state.mobile = "";
      state.errorMsg = false;
      state.successMsg = "";
    },
    resetMessage(state) {
      state.error = "";
      state.successMsg = "";
      state.errorMsg = false;
    }
  },
  extraReducers: (builder) => {
    // Handle sendOtpAuth
    builder
      .addCase(sendOtpAuth.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.successMsg = "";
      })
      .addCase(sendOtpAuth.fulfilled, (state, action) => {
        state.loading = false;
        state.otpSent = true;
        state.mobile = action.payload?.mobile || "";
        state.successMsg = "OTP sent successfully";
        state.error = "";
        state.errorMsg = false;
      })
      .addCase(sendOtpAuth.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to send OTP";
        state.errorMsg = true;
        state.successMsg = "";
      });

    // Handle verifyOtpAuth
    builder
      .addCase(verifyOtpAuth.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.successMsg = "";
      })
      .addCase(verifyOtpAuth.fulfilled, (state, action) => {
        state.loading = false;
        state.verified = true;
        state.user = action.payload;
        state.successMsg = "OTP verified successfully";
        state.error = "";
        state.errorMsg = false;
      })
      .addCase(verifyOtpAuth.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to verify OTP";
        state.errorMsg = true;
        state.successMsg = "";
      });
  }
});

export const {
  setLoading,
  setOtpSent,
  setMobile,
  apiError,
  reset,
  resetMessage
} = otpLoginSlice.actions;

export default otpLoginSlice.reducer;
